import {type SetStateAction} from 'react';
export type {SetStateAction} from 'react';
import type {SetPartialStateAction} from './types';
export type {SetPartialStateAction} from './types';

export const stateUpdaterFn = <T>(state: SetStateAction<T>, prev: T) => {
	return typeof state === 'function' ? (state as (prev: T) => T)(prev) : state;
};

export const stateUpdaterPartialFn = <T>(
	state: SetPartialStateAction<T>,
	prev: T,
) => {
	return typeof state === 'function'
		? (state as (prev: T) => Partial<T>)(prev)
		: state;
};

export type GetMutableStateReturnType<
	S,
	M extends readonly (keyof Partial<S>)[],
> = {
	[K in M[number]]: S[K];
};

// M is the mutable subset of the state that the updater is allowed to update, S is the full state
// we want the resulting type to be S with the keys in M being reflcted as set since S is the full state
export const getMutableState = <
	S extends Object,
	M extends readonly (keyof Partial<S>)[] = readonly (keyof Partial<S>)[],
>(
	mutableProps: M,
	prev: S,
) => {
	return mutableProps.reduce<GetMutableStateReturnType<S, M>>(
		(acc, prop) => ({
			...acc,
			[prop]: prev[prop],
		}),
		{} as GetMutableStateReturnType<S, M>,
	);
};
